import {
  allowChunkTouch,
  levelChangeThresholdZoom,
  localhostURL,
  wheelTriggerR,
} from '../constants'
import { NodeTree } from '../scripts/nodeTree'
import { divideText } from '../scripts/text'
import { getColor, map, sleep } from '../scripts/utils'
import {
  hardcodeLevels,
  hardcodeNodes,
  hardcodeSeg,
  hardcodeSegmentation,
} from './hardcode'

// const logStyle = 'font-family: monospace'
const logStyleEm = 'font-family: monospace; color: red'

let levelsOfEachNode = null
let segmentation = null
let numOfRoots = 0

export const nodeTree = { current: undefined }

export async function getSegmentation(colorTemplate, text, textArray = null) {
  if (textArray === null) textArray = divideText(text)

  const totalLength = textArray.length
  console.log(`Total word count ${totalLength}`)

  levelsOfEachNode = Array(totalLength).fill(0)

  nodeTree.current = new NodeTree(undefined, textArray)

  ////
  if (!allowChunkTouch) {
    // return produceSegmentation(
    //   {
    //     0: Array(textArray.length).fill(1),
    //   },
    //   textArray,
    //   colorTemplate,
    //   textArray.length
    // )

    levelsOfEachNode = hardcodeLevels
    segmentation = hardcodeSegmentation
    numOfRoots = 14

    nodeTree.current.constructFromNodes(hardcodeNodes, totalLength)

    return {
      segmentation: produceSegmentation(
        hardcodeSeg,
        textArray,
        colorTemplate,
        totalLength
      ),
    }
  }
  ////

  /* 1 ------------------------------------------------------------------------ */
  // PROD
  return fetch(`http://${localhostURL}:3000/segment/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
  })
    .then(response => response.json())
    .then(json => {
      segmentation = json.segmentation
      numOfRoots = json.numOfRoots

      // check the level of the next block in this array, and map the speeds to
      // [level of the next block, one level upper, two levels upper]?
      levelsOfEachNode = json.levels
      // console.log('levelsOfEachNode: ', levelsOfEachNode)

      if (typeof segmentation !== 'object')
        throw '[CoreNLP] No segmentation error.'

      console.log('%cSEGMENTATION', logStyleEm)
      console.log(Object.keys(segmentation).length)
      console.log(segmentation)

      // const s = segmentation
      const s = fixSegmentation(segmentation, totalLength)
      console.log('%cFIXED SEGMENTATION', logStyleEm)
      console.log(Object.keys(s).length)
      console.log(s)

      console.log('%cLEVELS', logStyleEm)
      console.log(levelsOfEachNode)

      console.log('%cNODE TREE', logStyleEm)
      // console.log(json.nodes)
      nodeTree.current.constructFromNodes(json.nodes, totalLength)
      console.log(nodeTree.current.rootNode)

      // Dirty fix - add 1 to the tail until the lengths match
      // for (let s in segmentation) {
      //   let t = segmentation[s].reduce((a, b) => a + b, 0)
      //   console.log(`Level${s.toString().padStart(2, '0')} count`, t)
      //   while (t < totalLength) {
      //     segmentation[s].push(1)
      //     t = segmentation[s].reduce((a, b) => a + b, 0)
      //   }
      // }

      const lengthsLevels = {
        0: Array(textArray.length).fill(1),
      }
      lengthsLevels[Object.size(s) + 1] = [textArray.length]

      return {
        segmentation: produceSegmentation(
          { ...lengthsLevels, ...s },
          textArray,
          colorTemplate,
          totalLength
        ),
      }
    })
  /* -------------------------------------------------------------------------- */

  /* 2 ------------------------------------------------------------------------ */
  // DEV
  // return sleep(2000).then(() => {
  //   const lengthsLevels = example.lengthsLevels(textArray)
  //   return produceSegmentation(lengthsLevels, textArray, colorTemplate)
  // })
  /* -------------------------------------------------------------------------- */
}

export const getLevelsOfEachNode = () => {
  return levelsOfEachNode
}

export const getNumOfRoots = () => {
  return numOfRoots
}

export const getTargetEndCount = currentCount => {
  let res = []
  let currentLevel = levelsOfEachNode[currentCount]
  // console.log('currentLevel: ', currentLevel)

  // current Level
  if (Object.keys(segmentation).length === currentLevel) {
    res.push(currentCount + 1)
  }
  let currentSeg = segmentation[Object.keys(segmentation).length - currentLevel] // segementation for this level.

  let numOfNodes = 0
  for (let idx = 0; idx <= currentSeg.length; idx++) {
    numOfNodes += currentSeg[idx]
    if (numOfNodes === 1 + currentCount) {
      res.push(currentSeg[idx + 1] + currentCount)
      break
    } else if (numOfNodes > 1 + currentCount) {
      res.push(numOfNodes - 1)
      break
    }
  }

  // upperLevel
  currentLevel -= 1
  if (Object.keys(segmentation).length === currentLevel) {
    res.push(currentCount + 1)
  }
  currentSeg = segmentation[Object.keys(segmentation).length - currentLevel] // segementation for this level.

  numOfNodes = 0
  for (let idx = 0; idx <= currentSeg.length; idx++) {
    numOfNodes += currentSeg[idx]
    if (numOfNodes === 1 + currentCount) {
      res.push(currentSeg[idx + 1] + currentCount)
      break
    } else if (numOfNodes > 1 + currentCount) {
      res.push(numOfNodes - 1)
      break
    }
  }

  // highestLevel
  currentLevel -= 1
  if (Object.keys(segmentation).length === currentLevel) {
    res.push(currentCount + 1)
  }
  currentSeg = segmentation[Object.keys(segmentation).length - currentLevel] // segementation for this level.

  numOfNodes = 0
  for (let idx = 0; idx <= currentSeg.length; idx++) {
    numOfNodes += currentSeg[idx]
    if (numOfNodes === 1 + currentCount) {
      res.push(currentSeg[idx + 1] + currentCount)
      break
    } else if (numOfNodes > 1 + currentCount) {
      res.push(numOfNodes - 1)
      break
    }
  }
  // console.log('res: ', res)
  return res
}

export const getTargetStartCount = currentCount => {
  let res = []
  let currentLevel = levelsOfEachNode[currentCount]
  // console.log('currentLevel: ', currentLevel)
  try {
    let targetLen = Object.keys(segmentation).length
  } catch (error) {
    console.error(error)
  }

  //current Level
  if (Object.keys(segmentation).length === currentLevel)
    res.push(currentCount - 1)
  let currentSeg = segmentation[Object.keys(segmentation).length - currentLevel] // segmentation for this level

  let numOfNodes = 0
  for (let idx = 0; idx <= currentSeg.length; idx++) {
    numOfNodes += currentSeg[idx]
    if (numOfNodes === currentCount) {
      res.push(currentSeg[idx])
      break
    } else if (numOfNodes > currentCount) {
      res.push(numOfNodes - currentSeg[idx])
      break
    }
  }

  // upperLevel
  currentLevel -= 1
  if (Object.keys(segmentation).length === currentLevel)
    res.push(currentCount - 1)
  currentSeg = segmentation[Object.keys(segmentation).length - currentLevel] // segmentation for this level

  numOfNodes = 0
  for (let idx = 0; idx <= currentSeg.length; idx++) {
    numOfNodes += currentSeg[idx]
    if (numOfNodes === currentCount) {
      res.push(currentSeg[idx])
      break
    } else if (numOfNodes > currentCount) {
      res.push(numOfNodes - currentSeg[idx])
      break
    }
  }

  // highestLevel
  currentLevel -= 1
  if (Object.keys(segmentation).length === currentLevel)
    res.push(currentCount - 1)
  currentSeg = segmentation[Object.keys(segmentation).length - currentLevel] // segementation for this level.

  numOfNodes = 0
  for (let idx = 0; idx <= currentSeg.length; idx++) {
    numOfNodes += currentSeg[idx]
    if (numOfNodes === currentCount) {
      res.push(currentSeg[idx])
      break
    } else if (numOfNodes > currentCount) {
      res.push(numOfNodes - currentSeg[idx])
      break
    }
  }

  // console.log('res: ', res)
  return res
}

export const produceSegmentation = (
  lengthsLevels,
  textArray,
  colorTemplate
  // totalLength
) => {
  const seg = {}
  let startCount = 0
  for (let level in lengthsLevels) {
    seg[level] = {}
    startCount = 0
    for (let i in lengthsLevels[level]) {
      let e = startCount + lengthsLevels[level][i]
      seg[level][i] = {
        order: parseInt(i),
        startCount: startCount,
        length: lengthsLevels[level][i],
        endCount: e - 1,
        subArray: textArray.slice(startCount, e),
        color: getColor(colorTemplate),
        // color: getColor(colorTemplate, lengthsLevels[level][i], totalLength),
      }
      startCount += lengthsLevels[level][i]
    }
  }

  return seg
}

// Fix the segmentation in the following ways
// - Make sure that all the levels are correct in length
// - Delete the level if it's almost all 1s
export const fixSegmentation = (segmentation, totalLength) => {
  const re = {}
  let counter = 1
  for (let s in segmentation) {
    if (
      totalLength === segmentation[s].reduce((a, b) => a + b, 0) &&
      _notTooMuchOnes(segmentation[s])
    )
      re[counter++] = segmentation[s]
  }

  return re
}

// const _fixLevels = (fix_segmentation, target_level_count) => {
//   const fix_levels = {}
//   let counter = 1
//   for (let s in fix_segmentation) {
//     current_length = fix_segmentation[s].length
//     next_length = fix_segmentation[s+1].length
//   }
//   return
// }

const _notTooMuchOnes = s => {
  return s.filter(i => i === 1).length / s.length < 1.1 // was 0.9, must <= 1
}

export const getDynamicSeg = (
  targetStartCount,
  targetEndCount,
  textArray,
  colorTemplate,
  totalLength
) => {
  const re = {}
  let reOrder = 0

  for (let i = 0; i < totalLength; i++) {
    let thisLength =
      i === targetStartCount ? targetEndCount - targetStartCount + 1 : 1
    let e = i === targetStartCount ? targetEndCount : i
    re[i] = {
      order: i,
      startCount: i,
      length: thisLength,
      endCount: e,
      subArray: textArray.slice(i, e + 1),
      color: getColor(colorTemplate),
      // color: getColor(colorTemplate, thisLength, totalLength),
    }
    if (i === targetStartCount) reOrder = i
    i = re[i].endCount
  }

  return [re, reOrder]
}

export const getPseudoSeg = (
  targetStartCount,
  targetEndCount,
  textArray,
  colorTemplate,
  thisMag,
  dynamicDistance
) => {
  let confidence
  if (thisMag > dynamicDistance) {
    thisMag -= dynamicDistance
    while (thisMag > /* levelChangeThresholdZoom */ dynamicDistance) {
      thisMag -= dynamicDistance /* levelChangeThresholdZoom */
    }
    confidence = thisMag / dynamicDistance /* levelChangeThresholdZoom */
  } else {
    confidence = thisMag / dynamicDistance
  }

  return {
    startCount: targetStartCount,
    length: targetEndCount - targetStartCount + 1,
    endCount: targetEndCount,
    subArray: textArray.slice(targetStartCount, targetEndCount + 1),
    color: [
      ...getColor(colorTemplate),
      Math.ceil(map(confidence, 0, 1, 0, 34)), // #22
    ],
  }
}
